<template>
    <fieldset class="about-you">
        <legend>About you</legend>

        <label-input
            label="First name"
            :required="true"
            v-model="person.nameFirst.$model"
            :validator="person.nameFirst"
            error-message="First name is required."
            name="nameFirst"
        />

        <label-input
            label="Last name"
            :required="true"
            v-model="person.nameLast.$model"
            :validator="person.nameLast"
            error-message="Last name is required."
            name="nameLast"
        />

        <label-input
            label="Address"
            :required="!userIsAdmin"
            v-model="person.address1.$model"
            :validator="person.address1"
            error-message="Address is required."
            name="address1"
            :input-class="[addressFieldsNeedingReview.includes('address1') ? 'review' : '']"
        />

        <label-input
            label="Address 2"
            v-model="person.address2.$model"
            name="address2"
            :input-class="[addressFieldsNeedingReview.includes('address2') ? 'review' : '']"
        />

        <label-input
            label="City"
            :required="!userIsAdmin"
            v-model="person.city.$model"
            name="city"
            :input-class="[addressFieldsNeedingReview.includes('city') ? 'review' : '']"

        />

        <label-input :label="userIsAdmin ? 'State / ZIP' : 'State * / ZIP *'">
            <template v-slot:custom>
                <input-only
                    :required="!userIsAdmin"
                    v-model="person.state.$model"
                    :validator="person.state"
                    error-message="State is required."
                    name="state"
                    style="width: 3rem;"
                    pattern="[A-Za-z]{2}"
                    maxlength="2"
                    title="Two letter state code"
                    :input-class="[addressFieldsNeedingReview.includes('state') ? 'review' : '']"
                />
                <input-only
                    :required="!userIsAdmin"
                    v-model="person.zip.$model"
                    :validator="person.zip"
                    error-message="ZIP is required."
                    name="zip"
                    style="width: 7rem; margin-left: 1em;"
                    maxlength="10"
                    :input-class="[addressFieldsNeedingReview.includes('zip') ? 'review' : '']"
                />
            </template>
        </label-input>

        <address-validation-status-bar
            v-if="userIsAdmin"
            :person="person"
            :may-validate="true"
            @validate="$emit('validate')"
        />

        <label-input label=" " v-show="addressFieldsNeedingReview.length">
            <template v-slot:custom >
                <span class="feedback">
                    Fix highlighted fields above and try again, or
                    <span class="feedback" style="white-space: nowrap;">
                        click here to accept the address as written:
                        <input type="checkbox" v-model="override" :value='true' @change="overrideChanged">
                    </span>
                </span>
            </template>
        </label-input>

        <phone-numbers
            :person="person"
            :phone-number-types="phoneNumberTypes"
            style="margin-top: 50px;"
        />
    </fieldset>
</template>

<script>
import InputOnly from '../../_components/form/InputOnly';
import LabelInput from '../../_components/form/LabelInput';
import AddressValidationStatusBar from './AddressValidationStatusBar';
import PhoneNumbers from './PhoneNumbers';

export default {
    components: {
        AddressValidationStatusBar,
        InputOnly,
        LabelInput,
        PhoneNumbers,
    },

    props: {
        person: {
            type: Object,
        },
        userIsAdmin: {
            type: Boolean,
        },
        newPerson: {
            type: Boolean,
        },
        phoneNumberTypes: {
            type: Array,
        },
    },

    data() {
        return {
            addressFieldsNeedingReview: [],
            override: false,
        };
    },

    // computed: {
    //     address() {
    //         return {
    //             address1: this.person.address1.$model,
    //             address2: this.person.address2.$model,
    //             city: this.person.city.$model,
    //             state: this.person.state.$model,
    //             zip: this.person.zip.$model,
    //         };
    //     },
    // },

    methods: {
        // TODO Where do these belong?
        reviewAddress(fields) {
            this.addressFieldsNeedingReview.splice(
                0,
                this.addressFieldsNeedingReview.length,
                ...[...fields.unconfirmed, ...fields.missing]
            );
            this.override = false;
        },
        clearReview() {
            this.addressFieldsNeedingReview.splice(
                0,
                this.addressFieldsNeedingReview.length
            );
            this.override = false;
        },
        overrideChanged() {
            this.$emit('set-address-status', this.override
                ? (this.userIsAdmin ? 5 : 4)
                : 1
            );
        },
    },
}
</script>

<style lang="scss">
.about-you {
    .review {
        border: 2px solid #d8842e !important;
    }
    .feedback {
        color: #d8842e;
        font-size: 16px;
    }
}
</style>
